import React from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import English from './config/translation/locales/en_US.json';
import Portuguese from './config/translation/locales/pt_BR.json';
import Spanish from './config/translation/locales/es_ES.json';
import { ConfigProvider } from 'antd';

export default function AppProvider({ children }) {
  let lang = English;
  const { locale } = useSelector(state => state.LanguageSwitcher.language);

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  if (locale === 'pt-BR') {
    lang = Portuguese;
  }
  if (locale === 'es-ES') {
    lang = Spanish;
  }

  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorPrimary: '#00abab',
        },
      }}
    >
      <IntlProvider
        locale={locale}
        messages={lang}
      >
        <ThemeProvider
          theme={{
            token: {
              colorPrimary: '#00abab',
            },
          }}
        >
          {children}
        </ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
  );
}
